import { render, staticRenderFns } from "./OwnVesselDisplayDurationTime.vue?vue&type=template&id=5ddf3d82&"
import script from "./OwnVesselDisplayDurationTime.vue?vue&type=script&lang=js&"
export * from "./OwnVesselDisplayDurationTime.vue?vue&type=script&lang=js&"
import style0 from "./OwnVesselDisplayDurationTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports